import { InvoiceCalculationType as BackendInvoiceCalculationType } from '@ianesthesie-kit/services';
import { InvoiceCalculationType } from './billing.slice';

/**
 * Maps the backend `InvoiceCalculationType` enum (UPPERCASE_SNAKE, the wire
 * format) to the FE representation used throughout the billing UI. The total
 * `Record<>` makes the compiler reject any backend value left unmapped, so a
 * new backend method can't silently slip through untranslated.
 */
export const BACKEND_TO_FE_CALCULATION_TYPE: Record<
  BackendInvoiceCalculationType,
  InvoiceCalculationType
> = {
  [BackendInvoiceCalculationType.ANESTHESIA_BASED]: 'anesthesiaBased',
  [BackendInvoiceCalculationType.SURGEON_BASED]: 'surgeonBased',
  [BackendInvoiceCalculationType.INSURANCE_BASED]: 'insuranceBased',
  [BackendInvoiceCalculationType.BRSS_BASED]: 'brssBased'
};

/** i18n key for a calculation type's human label, reusing the invoice-card keys. */
export const calculationTypeLabelKey = (type: BackendInvoiceCalculationType) =>
  `doctor-dashboard.details.billingCard.invoiceCalculationType.${BACKEND_TO_FE_CALCULATION_TYPE[type]}` as const;
